import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { DamageDocumentTypesService } from '../damage-document-types.service';

@Pipe({
    name: 'damageDocumentType$',
    standalone: true,
})
export class DamageDocumentTypePipe implements PipeTransform {
    private damageDocumentTypesService = inject(DamageDocumentTypesService);

    public transform(documentTypeId: number, insuranceTypeId: number): Observable<string> {
        return this.damageDocumentTypesService.getDocumentTypes(insuranceTypeId).pipe(
            map((documentTypes) => documentTypes.find((type) => type.id === documentTypeId)),
            map((documentType) => documentType?.description ?? 'Unbekannter Dokumententyp'),
        );
    }
}
